import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "select2/dist/css/select2.min.css";
import "quill/dist/quill.core.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/vendor/nucleo/css/nucleo.css";
import "assets/scss/argon-dashboard-pro-react.scss?v1.2.1";
import Admin from "layouts/Admin.js";
import Login from "views/pages/examples/Login";
import ListingConfirmation from "views/pages/examples/ListingConfirmation";
import ForgotPassword from "forgot-password/index";
import ResetPassword from "reset-password/index";
import { AuthProvider } from "context/AuthContext";
import { TranslationProvider, useTranslation } from "context/TranslationProvider";
import PrivateRoute from "routes/PrivateRoute.js";
import PublicRoute from "routes/PublicRoute.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NotificationProvider from "providers/NotificationProvider";

const VerifyEmail = React.lazy(() => import("verify-email/index"));

const LoadingFallback = () => {
  const { t } = useTranslation();
  return <div>{t("common.loading", "Loading...")}</div>;
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <TranslationProvider>
      <ToastContainer />
      <NotificationProvider>
      <Routes>
        {/* Default home page */}
        <Route
          path="/listing-confirmation"
          element={<ListingConfirmation />}
        />
        <Route
          path="/verify-email"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <VerifyEmail />
            </Suspense>
          }
        />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route
          path="/*"
          element={
            <PublicRoute>
              <Routes>
                <Route path="login" element={<Login />} />
                <Route path="forgot-password" element={<ForgotPassword />} />
                <Route path="reset-password" element={<ResetPassword />} />
                <Route path="*" element={<Navigate to="/login" replace />} />
              </Routes>
            </PublicRoute>
          }
        />

        {/* Admin routes */}
        <Route
          path="/admin/*"
          element={
            <PrivateRoute allowedRoles={[
              "super_admin",
              "admin",
              "moderator",
              // "marketing"
            ]}>
              <Admin />
            </PrivateRoute>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
      </NotificationProvider>
      </TranslationProvider>
    </AuthProvider>
  </BrowserRouter>
);
